import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import Bank from "./img2.jpg";
import "./Home.css";

function Home() {
  return (
    <div className="home-bg">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col md={8} className="text-center">
            
            <h1 className="home-title mb-4">Welcome to Secure Bank</h1>

            <div className="image-wrapper">
              <Image
                src={Bank}
                fluid
                rounded
                className="bank-img"
              />
            </div>

            <p className="home-text mt-4">
              Safe, Secure, Reliable Banking Experience.
            </p>

          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Home;
